import React from "react";
import { connect } from "react-redux";
import moment from "moment";

import language from "../../../language";
import { Button } from "../../Button";
import { Separator } from "../../Separator";
import toastMessage from "../../../utils/toastMessage";
import { canEndorseEmergency } from "../../../utils/handleAccessRoles";
import { endorseEmergencyRequest } from "../../../utils/queries/emergency";

/**
 * Hospital clinical administration signing an emergency release after the
 * fact - the bottom half of the paper form.
 *
 * The deadline is shown rather than only enforced. A doctor finding out they
 * are locked out at the moment they need emergency release again is the worst
 * possible time to learn it, so the clock is visible from the start to anyone
 * looking at the request.
 */
class Endorsement extends React.Component {
  state = { canEndorse: false, isSubmitting: false };

  componentDidMount = async () => {
    this.setState({ canEndorse: await canEndorseEmergency() });
  };

  onEndorse = async () => {
    try {
      this.setState({ isSubmitting: true });

      await endorseEmergencyRequest(this.props.request._id);

      toastMessage(
        "success",
        language[this.props.defaultLanguage].emergency_endorsement
      );

      this.setState({ isSubmitting: false });

      if (this.props.onEndorsed) this.props.onEndorsed();
    } catch (error) {
      toastMessage("error", error);
      this.setState({ isSubmitting: false });
    }
  };

  // Hours left before this release locks its doctor out, or how far past it
  // already is.
  deadline = () => {
    const { request, options } = this.props;
    const hours = options?.endorsementDeadlineHours || 72;

    return moment(request.createdAt).add(hours, "hours");
  };

  render() {
    const { request, options, defaultLanguage } = this.props;
    const endorsement = request?.emergencyRelease?.endorsement || {};
    const endorsed = endorsement.status === "endorsed";
    const deadline = this.deadline();
    const overdue = !endorsed && moment().isAfter(deadline);

    return (
      <>
        <Separator
          title={language[defaultLanguage].emergency_endorsement}
          titleClassName="text-primary"
        />
        <div className="col-md-12">
          {endorsed ? (
            <>
              <p>{endorsement.statement}</p>
              <p className="text-bold mt-2">
                {language[defaultLanguage].emergency_endorsed_by}:{" "}
                {endorsement.name}
                {endorsement.at
                  ? " - " + moment(endorsement.at).format("lll")
                  : ""}
              </p>
            </>
          ) : (
            <>
              <p className={overdue ? "text-error" : "text-muted"}>
                {language[defaultLanguage].emergency_awaiting_endorsement}
                {" - "}
                {overdue
                  ? language[defaultLanguage].emergency_endorsement_help
                  : moment(deadline).fromNow()}
              </p>
              {this.state.canEndorse && (
                <>
                  <p>{options?.endorsementStatement}</p>
                  <div className="mt-3">
                    <Button
                      text={language[defaultLanguage].emergency_endorse}
                      onPress={this.onEndorse}
                      isSubmitting={this.state.isSubmitting}
                    />
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;

  return { defaultLanguage };
};

export default connect(mapStateToProps)(Endorsement);
